export const text = {
  heading: 'Industry',
  industryPlaceholder: 'Enter industry name',
  industryName: 'Industry Name',
  addIndustry: 'Add Industry',
};
